/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { StepperComponent } from './stepper';
export * from './stepper';
export * from './stepper-adapter';
export * from './stepper-constants';
export * from './stepper-core';
export function defineStepperComponent() {
    defineCustomElement(StepperComponent);
}
